
import HealthInfoService from "./HealthInfoService";
import HealthInfoDetail from "./HealthInfoDetail";
import { HealthStatusType } from "./HealthStatusType";


export default class HealthInfo 
{
    constructor(gcid, uid, locationId, lastRefreshed, coreHealth, coreDbHealth, authHealth, authResourceHealth)
    {
        this.gcid = gcid || "";
        this.uid = uid || "";
        this.lastRefreshed = lastRefreshed || HealthInfoDetail
        this.locationId = locationId || "";
        this.coreHealth = coreHealth || new HealthInfoService();
        this.coreDbHealth = coreDbHealth || new HealthInfoService();
        this.authHealth = authHealth || new HealthInfoService();
        this.authResourceHealth = authResourceHealth ||  new HealthInfoService();
   
    }

    overallStatus()
    {
        var testOk = this.coreHealth.currentUpdate.updateStatus == HealthStatusType.OK;
        var hasCurrentError = (
            (this.coreHealth.currentUpdate?.updateStatus != HealthStatusType.OK) 
            || (this.coreDbHealth.currentUpdate?.updateStatus != HealthStatusType.OK) 
            || (this.authHealth.currentUpdate?.updateStatus  != HealthStatusType.OK) 
            || (this.authResourceHealth.currentUpdate?.updateStatus  != HealthStatusType.OK)
        );


        var hasPreviousError =  
        (
            (this.coreHealth.lastProblemUpdate) &&
            (
                (this.coreHealth.lastProblemUpdate?.updateStatus != HealthStatusType.OK) 
                || (this.coreDbHealth.lastProblemUpdate?.updateStatus != HealthStatusType.OK) 
                || (this.authHealth.lastProblemUpdate?.updateStatus  != HealthStatusType.OK) 
                || (this.authResourceHealth.lastProblemUpdate?.updateStatus  != HealthStatusType.OK)
            )
        );

        if (hasCurrentError) return HealthStatusType.ERROR;
        if (hasPreviousError) return HealthStatusType.WARNING;
        return HealthStatusType.OK;
        
    }


}
